export default __webpack_public_path__ + "static/media/Identify-risk-Assessment-Mangement.e84b907a.svg";